/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import ActionModel from 'cio/models/action';
import TemplateModel from 'cio/models/template';

interface TwilioActionArgs {
  action: ActionModel;
  disableOverlay: boolean;
  hasContent: boolean;
  disabled: boolean;
  template: TemplateModel | null;
  sanitizedBody: string;
  hasReadOnlyPermission: boolean;
}

export default class TwilioAction extends Component<TwilioActionArgs> {}
